// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"728":"c935b753","1726":"c935b753","6191":"04966bad","8328":"7e38ea54"}[chunkId] + ".chunk.css";
};